import React from 'react';
import PropTypes, {any} from 'prop-types';
import { connect } from 'react-redux';

import { Select, Spin } from 'antd';
import EditWrapper from '../EditWrapper';

import { open, close } from './SelectEdit.reducer';
import selector from './SelectEdit.selector';

import {
  Content,
  StyledTitle,
  SelectedWrapper,
  Container
} from './SelectEdit.styles';

import { optionShape } from './SelectEdit.types';
import { infoShape } from '../../types/info.types';
import { colors } from '../../utils/variables.styles';
import withTranslation from "../WithTranslation/WithTranslation";
import {CaretDownOutlined} from "@ant-design/icons";

class SelectEdit extends React.Component {
  static propTypes = {
    close: PropTypes.func.isRequired,
    open: PropTypes.func.isRequired,
    info: infoShape,
    isEdit: PropTypes.bool,
    loading: PropTypes.bool,
    nested: PropTypes.bool,
    opened: PropTypes.number,
    options: PropTypes.arrayOf(optionShape),
    selected: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    title: PropTypes.string,
    onChange: PropTypes.func,
    onEditClick: PropTypes.func,
    t: PropTypes.func.isRequired,
    selectedValue: any,
  };

  static defaultProps = {
    info: null,
    nested: false,
    selected: null,
    onChange: () => {},
    onEditClick: null,
    loading: false,
    options: [],
    title: null,
    opened: null,
    isEdit: false,
    translationsData: null,
    selectedValue: null,
  };

  id = Math.random();

  toggleEdit = () => {
    if (this.id === this.props.opened) {
      this.props.close();
    } else {
      this.props.open(this.id);
    }
  }

  render() {
    const isOpened = this.props.opened === this.id;
    // console.log('[SelectEdit] render - isOpened:', isOpened, 'opened:', this.props.opened, 'id:', this.id);
    const { t, options, selected } = this.props;

    // helper: jaką wartość pokazać w trybie "zamkniętym"
    const renderSelectedValue = () => {
      if (!options || options.length === 0) {
        return t('lack_off');
      }

      const hasSelected = selected !== null && selected !== undefined;

      // 🔸 NIC nie wybrane, ale jest dokładnie JEDNA opcja
      // -> pokaż tę jedyną opcję zamiast "brak"
      if (!hasSelected) {
        if (options.length === 1) {
          return options[0].value;
        }
        return t('lack_off');
      }

      // 🔸 coś jest w selected, szukamy po id (string/number bez znaczenia)
      const selectedOption = options.find(
        (el) => el && String(el.id) === String(selected)
      );

      if (selectedOption && selectedOption.value) {
        return selectedOption.value;
      }

      // fallback: jeśli mimo wszystko nie znaleźliśmy,
      // a jest tylko jedna opcja, to ją pokaż
      if (options.length === 1) {
        return options[0].value;
      }

      return t('lack_off');
    };
    return (
      <Spin spinning={this.props.loading}>
        <Container nested={this.props.nested}>
          <EditWrapper
            info={this.props.info}
            isEdit={isOpened}
            onEditClick={this.props.onEditClick ? this.props.onEditClick : this.toggleEdit}
            noEdit={
              (this.props.loading
                || (this.props.options && this.props.options.length <= 1)
              ) && !this.props.isEdit
            }
            nested={this.props.nested}
          >
            <Content>
              {
                !this.props.loading ? (
                  <React.Fragment>
                    <StyledTitle>
                      {this.props.title}
                      {this.props.options.length > 0 && ':'}
                    </StyledTitle>
                    {
                      isOpened ? (
                        <div style={{ width: '100%' }}>
                          <Select
                            suffixIcon={
                              <CaretDownOutlined
                                fill={colors.selectArrow}
                                className="custom-chevron"
                              />
                            }
                            style={{ width: '100%' }}
                            value={this.props.selected}
                            onChange={this.props.onChange}
                            onDeselect={() => { this.props.close(); }}
                            onBlur={() => { this.props.close(); }}
                            onSelect={this.toggleEdit}
                          >
                            {
                              this.props.options && this.props.options.map((el) => (
                                <Select.Option key={el.id} value={el.id}>
                                  {el.value}
                                </Select.Option>
                              ))
                            }
                          </Select>
                        </div>
                      ) : (
                        this.props.options.length > 0 && (
                          <>
                            {
                              this.props.selected != null && (
                                <SelectedWrapper>
                                  {(this.props.options.find((el) => el && el.id === this.props.selected) || {}).value || t('lack_off')}
                                </SelectedWrapper>
                              )
                            }
                            {
                              this.props.selected == null && this.props.selectedValue != null && (
                                <SelectedWrapper>
                                  {this.props.selectedValue}
                                </SelectedWrapper>
                              )
                            }
                          </>
                        )
                      )
                    }
                  </React.Fragment>
                ) : null
              }
            </Content>
          </EditWrapper>
        </Container>
      </Spin>
    );
  }
}

const mapDispatchToProps = {
  open,
  close
};

export default connect(selector, mapDispatchToProps)(withTranslation(SelectEdit));
